<template>
    <!-- page-wrapper Start-->
     <div class="page-wrapper">
         <div class="container-fluid">
             <!-- sign up page start-->
             <div class="authentication-main">
                <div class="row">
                  <div class="col-sm-12 p-0">
                    <div class="auth-innerright">
                    <div class="authentication-box">
                      <div v-show="!showUploadImage && !showUploadImageRecv" class="gradient-gy card">
                        <h4  class="text-center text-white mt-2">{{ $t('approvedTrans.title') }}</h4>
                        <div class="col-sm-12 ">
                          <div class="d-flex flex-row justify-content-between my-2">
                            <feather 
                              @click="refreshTaskList" 
                              class="text-white" 
                              type="refresh-cw"  
                              size="25" 
                              v-b-popover.hover.top="$t('approvedTrans.refreshTaskListMsg')">
                            </feather>      
                            <h4 class=" text-warning f-w-600">{{ $t('approvedTrans.taskList') }}</h4>
                            <feather 
                              @click="logout" 
                              class="text-danger" 
                              type="log-out"  
                              size="25" 
                              v-b-popover.hover.top="$t('approvedTrans.logoutMsg')">
                            </feather>   
                          </div>
                          <div class="row justify-content-start ml-2">
                              <span class="text-warning"> {{ $t('approvedTrans.asOf') }}</span>
                              <span class="text-white"> {{ asOf }} </span>   
                          </div>
                          <b-table
                            sticky-header
                            head-variant="light"
                            table-variant="info"
                            show-empty
                            stacked="false"
                            sort-icon-left
                            :busy="isBusy"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :items="items"
                            :fields="fields"
                            :current-page="currentPage"
                            :per-page="perPage"
                          >
                          <template #cell(transInfo)="row" >
                            <button  size="sm" @click="openModalTransInfo(row.item, $event.target )">..{{ row.item.transId.slice(8, 11) }}</button>
                          </template>
                          <template #cell(actDriver)="row" >
                            <button v-show="row.item.transStatus1 == 'accept' || row.item.transStatus1 == 'edit'" size="sm" variant="success" @click="actInspRels(row.item)" class="m-1 bg-success text-white border">
                              {{ $t('approvedTrans.inspForm') }}
                            </button>
                            <button v-show="row.item.transStatus1 == 'accept' || row.item.transStatus1 == 'edit'" size="sm" variant="primary" @click="actUploadImage(row.item)" class="m-1 bg-primary text-white border">
                              {{ $t('approvedTrans.uploadImage') }}
                            </button>
                            <button v-show="row.item.transStatus1 == 'accept' || row.item.transStatus1 == 'edit'"  size="sm" variant="dark" @click="actCloseJobRels(row.item)" class="m-1 bg-dark text-white border">
                              {{ $t('approvedTrans.closeJob') }}
                            </button>
                            <button v-show="row.item.transStatus1 == 'done'"  size="sm" variant="danger" @click="actEditRels(row.item)" class="m-1 bg-warning text-dark border">
                              {{ $t('approvedTrans.edit') }}
                            </button>
                          </template>
                          <template #cell(actDriverRecv)="row" >
                            <button  v-show="row.item.transStatus2 == 'accept' || row.item.transStatus2 == 'edit'" size="sm" variant="success" @click="actInspRecv(row.item)" class="m-1 bg-success text-white border">
                              {{ $t('approvedTrans.inspForm') }}
                            </button>
                            <button v-show="row.item.transStatus2 == 'accept' || row.item.transStatus2 == 'edit'"  size="sm" variant="primary" @click="actUploadImageRecv(row.item)" class="m-1 bg-primary text-white border">
                              {{ $t('approvedTrans.uploadImage') }}
                            </button>
                            <button v-show="row.item.transStatus2 == 'accept' || row.item.transStatus2 == 'edit'"  size="sm" variant="dark" @click="actCloseJobRecv(row.item)" class="m-1 bg-dark text-white border">
                              {{ $t('approvedTrans.closeJob') }}
                            </button>
                            <button v-show="row.item.transStatus2 == 'done'"  size="sm" variant="danger" @click="actEditRecv(row.item)" class="m-1 bg-warning text-dark border">
                              {{ $t('approvedTrans.edit') }}
                            </button>
                          </template>
                          <template #empty>
                              <h5>{{ $t('reuse.noRecord') }}</h5>
                          </template>
                          </b-table>
                          <b-row>
                              <div class="row col-sm-8 ">
                              <b-col class="my-1 ml-3">
                                  <b-pagination
                                  v-model="currentPage"
                                  :total-rows="totalRows"
                                  :per-page="perPage"
                                  align="fill"
                                  class="my-0"
                                  ></b-pagination>
                              </b-col>   
                              </div>
                          </b-row>

                        </div>
                      </div>
                      <b-modal
                        id="transInfoModal" 
                        :title="this.$t('approvedTrans.transInfoModalTitle')"
                        v-model="showTransInfoModal"
                        header-bg-variant="info"
                        header-text-variant="light"
                        body-bg-variant="light"
                        body-text-variant="dark"
                        size="lg"
                        hide-footer
                      >
                        <div class="d-flex flex-row justify-content-start ml-3 mb-2">
                          <div class="row">
                            <h5 class="mx-2 text-dark">{{$t('approvedTrans.transId')}}</h5> 
                            <span class="text-primary ml-2"> {{ transInfo.mTxId }}</span>                                               
                          </div>
                          <!-- <div class="row ml-5">
                            <h5 class="mx-2 text-dark"> {{ $t('approvedTrans.startAt') }}</h5>
                            <span class="text-white bg-dark">
                              {{ $moment(transInfo.startAt).format("YY-MM-DD @ HH:mm") }}
                            </span>
                          </div>                 -->
                        </div>
                        <div class="ml-3">
                          <div class="row ml-2">
                            <h5 class="text-dark">{{ $t('matchTx.compNameLocalRels') }} : </h5>
                            <span class="text-primary ml-2"> {{ transInfo.compNameLocalRels }}</span>                
                            <a><u class=" ml-2 mb-2 fw-bold text-warning" style="font-size:16px;" @click="googleMapsLinkRels"><i class="icofont icofont-map-search mr-2 " style="font-size:25px"></i> {{ $t('approvedTrans.map') }}</u></a>                                              
                          </div>
                          <div class="row ml-2">
                            <h5 class="text-dark"> {{ $t('approvedTrans.startAt') }} : </h5>
                            <span class="text-white bg-dark mx-2">
                              {{ $moment(transInfo.startAt).format("YY-MM-DD @ HH:mm") }}
                            </span>
                          </div>   
                          <span class="text-info  ml-2"> {{ transInfo.contRelsAddress }}</span>                 
                        </div>
                        <div class="divider my-2"> </div>
                        <div class="ml-3">
                          <div class="row ml-2">
                            <h5 class="text-dark">{{ $t('matchTx.compNameLocalReqr') }} : </h5>
                            <span class="text-primary ml-2"> {{ transInfo.compNameLocalReqr }}</span>
                            <a><u class=" ml-2 mb-2 fw-bold text-warning" style="font-size:16px " @click="googleMapsLinkReqr"><i class="icofont icofont-map-search mr-2 " style="font-size:25px"></i> {{ $t('approvedTrans.map') }}</u></a>                                                                
                          </div>
                            <span class="ml-2 text-info"> {{ transInfo.contReqrAddress }}</span>                
                        </div>
                        <div class="divider my-2"> </div>
                        <b-row class="mx-auto">
                          <b-col>
                            <h5 class="f-w-600">{{$t('container.contId')}}</h5> 
                            <span class="text-info"> {{ transInfo.contId }}</span> 
                          </b-col>
                          <b-col>
                            <h5 class="f-w-600">{{$t('approvedTrans.contNo')}}</h5> 
                            <span class="text-info"> {{transInfo.contNo}} </span> 
                          </b-col>                                            
                          <b-col>
                            <h5 class="f-w-600">{{$t('approvedTrans.typeSize')}}</h5> 
                            <span class="text-info"> {{transInfo.contType}} : {{ transInfo.contSize }}</span> 
                          </b-col>
                            <b-col>
                              <h5 class="f-w-600">{{$t('container.tare')}}</h5> 
                              <span class="text-info"> {{transInfo.tare}} </span> 
                            </b-col>
                            <b-col>
                              <h5 class="f-w-600">{{$t('matchTx.agent')}}</h5> 
                              <span class="text-info"> {{transInfo.agent}} </span> 
                            </b-col>
                        </b-row>
                        <div class="divider my-2"> </div>
                        <div class="divider"> </div>
                        <div >            
                          <b-button
                            variant="primary"
                            size="md"
                            class="float-right"
                            @click="showTransInfoModal = false"
                          >
                            {{ $t('truck.ok') }}
                          </b-button>
                        </div>
                      </b-modal>
                      <b-modal
                        :title="$t('approvedTrans.inspFormModalTitle')"
                        v-model="showInspFormModalRels"
                        header-bg-variant="info"
                        header-text-variant="dark"
                        body-bg-variant="light"
                        body-text-variant="dark"
                        size="md"
                        hide-footer
                      >
                        <b-row class="mb-1 ml-3">
                          <b-row class="mx-2">
                            <h5 class="text-primary">{{$t('approvedTrans.transId')}} </h5> 
                            <span class="text-info ml-2">{{transId}} </span>                                             
                          </b-row>
                          <b-row class="mx-2">
                            <h5 class="text-primary">{{$t('container.contId')}} </h5> 
                            <span class="text-info ml-3">{{contId}} </span>                                             
                          </b-row>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="4">{{ $t('truck.licensePlate') }}</b-col>
                          <b-col>
                            <input v-model="licensePlate" class="form-control" type="text" id="licensePlate" disabled>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="4">{{ $t('approvedTrans.driverName') }}</b-col>
                          <b-col>
                            <input v-model="driverName" class="form-control" type="text" id="driverName" disabled>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="4">{{ $t('driver.driverLicenseNo') }}</b-col>
                          <b-col>
                            <input v-model="driverLicenseNo" class="form-control" type="text" id="driverLicenseNo" disabled>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="4">{{ $t('container.contNo') }}</b-col>
                          <b-col>
                            <input v-model="contNo" class="form-control" type="text" id="contNo" >
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="4">{{ $t('approvedTrans.contSpecReqr') }}</b-col>
                          <b-row class="ml-1">
                              <b-col >
                                <input v-model="contSpecReqr" class="form-control" type="text" id="contSpecReqr" disabled>
                              </b-col>                                         
                              <div class="mt-2">
                                <label class="switch">
                                  <input type="checkbox" v-model="contSpecInsp">
                                  <span class="slider round"></span>
                                </label>
                              </div>
                              <span v-show="!contSpecInsp" class="mt-1 ml-2 text-muted" style="font-size: 16px">{{ $t('approvedTrans.reject') }} </span>  
                              <span v-show="contSpecInsp" class="mt-1 ml-2 text-success f-w-800" style="font-size: 16px;">{{ $t('approvedTrans.pass') }} </span>  
                          </b-row>
                        </b-row>
                        <b-row v-show="sealNo != ''" class="mb-1">
                          <b-col cols="4">{{ $t('approvedTrans.sealNo') }}</b-col>
                          <b-col>
                            <input v-model="sealNo" class="form-control" type="text" id="sealNo" disabled >
                          </b-col>
                        </b-row>
                        <div>
                          <table class="table table-bordered table-striped mx-auto">
                            <tr class="table-warning"><th class="col-sm-4" style="font-size: 14px">{{ $t('approvedTrans.checkpoint') }}</th><th class="gradient-gy">{{$t("approvedTrans.outside")}}</th><th class="gradient-yg">{{$t("approvedTrans.inside")}}</th><th>{{$t("approvedTrans.remark")}}</th></tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.leftSide') }}</td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="left_out">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="left_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="left_rem"></td>
                            </tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.rightSide') }}</td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="right_out">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="right_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="right_rem"></td>
                            </tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.door') }}</td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="door_out">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="door_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="door_rem"></td>
                            </tr>  
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.undercarriage') }}</td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="undercarriage_out">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td>
                              </td>
                              <td><input type="text" v-model="undercarriage_rem"></td>
                            </tr>                                   
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.roof') }}</td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="roof_out">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td>
                              </td>
                              <td><input type="text" v-model="roof_rem"></td>
                            </tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.ceiling') }}</td>                                              
                              <td>
                              </td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="ceiling_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="ceiling_rem"></td>
                            </tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.frontWall') }}</td>                                              
                              <td>
                              </td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="frontWall_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="frontWall_rem"></td>
                            </tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.floor') }}</td>                                              
                              <td>
                              </td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="floor_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="floor_rem"></td>
                            </tr>
                          </table>
                        </div>
                        <div>
                          <b-form-group>
                            <b-row class="my-2">
                              <h5 class="mx-3">{{ $t('approvedTrans.sumResult') }} : </h5>
                              <b-form-radio-group
                                id="btn-radios-2"
                                v-model="sumResult"
                                :options="sumOptions"
                                :button-variant="sumResult == 'reject' ? 'outline-danger': sumResult == 'condPass' ? 'outline-warning':'outline-success' "
                                size="sm"
                                name="radio-btn-outline"
                                buttons
                              ></b-form-radio-group>                                              
                            </b-row>
                            <b-row v-show="sumResult == 'condPass'" class="col-sm-12">
                              <h6 class="col-sm-3" >{{ $t('approvedTrans.specifyCond') }} : </h6>
                              <input class="col-sm-9" type="text" v-model="sum_rem">
                            </b-row>
                          </b-form-group>
                        </div>
                        <div class="row col-sm-12">
                          <h5 class="f-w-600 mt-2 mr-5">{{ $t("approvedTrans.inspr") }} : </h5> 
                          <input class="col-sm-4" type="text" v-model="inspecter">         
                          <div class="col-sm-4 ml-5">   
                            <datepicker 
                              v-model="inspDate"               
                              input-class="datepicker-here form-control digits" 
                              :disabled-dates="disabledDates"  
                              :format="format" 
                              :placeholder="$t('transport.datePh')"
                              :language="th"
                            >
                            </datepicker>              
                          </div>
                        </div>
                        <div class="d-flex flex-row justify-content-end mt-2">
                          <b-button
                            variant="warning"
                            size="sm"
                            class="mx-4"
                            @click="clickNo"
                            >
                            {{ $t('container.no') }}
                            </b-button>
                          <b-button
                            variant="primary"
                            size="sm"
                            class="float-right"
                            @click="clickSaveRels"
                          >
                            {{ $t('seal.save') }}
                          </b-button>
                        </div>
                      </b-modal>
                      <b-modal
                        :title="$t('approvedTrans.inspFormModalTitleRecv')"
                        v-model="showInspFormModalRecv"
                        header-bg-variant="info"
                        header-text-variant="dark"
                        body-bg-variant="light"
                        body-text-variant="dark"
                        size="md"
                        hide-footer
                      >
                        <b-row class="mb-1 ml-3">
                          <b-row class="mx-2">
                            <h5 class="text-primary">{{$t('approvedTrans.transId')}} </h5> 
                            <span class="text-info ml-2">{{transId}} </span>                                             
                          </b-row>
                          <b-row class="mx-2">
                            <h5 class="text-primary">{{$t('container.contId')}} </h5> 
                            <span class="text-info ml-3">{{contId}} </span>                                             
                          </b-row>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="4">{{ $t('truck.licensePlate') }}</b-col>
                          <b-col>
                            <input v-model="licensePlate" class="form-control" type="text" id="licensePlate" disabled >
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="4">{{ $t('approvedTrans.driverName') }}</b-col>
                          <b-col>
                            <input v-model="driverName" class="form-control" type="text" id="driverName" disabled>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="4">{{ $t('driver.driverLicenseNo') }}</b-col>
                          <b-col>
                            <input v-model="driverLicenseNo" class="form-control" type="text" id="driverLicenseNo" disabled>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="4">{{ $t('container.contNo') }}</b-col>
                          <b-col>
                            <input v-model="contNo" class="form-control" type="text" id="contNo" disabled>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="4">{{ $t('approvedTrans.contSpecReqr') }}</b-col>
                          <b-row class="ml-1">
                              <b-col >
                                <input v-model="contSpecReqr" class="form-control" type="text" id="contSpecReqr" disabled>
                              </b-col>                                         
                              <div class="mt-2">
                                <label class="switch">
                                  <input type="checkbox" v-model="contSpecInsp">
                                  <span class="slider round"></span>
                                </label>
                              </div>
                              <span v-show="!contSpecInsp" class="mt-1 ml-2 text-muted" style="font-size: 16px">{{ $t('approvedTrans.reject') }} </span>  
                              <span v-show="contSpecInsp" class="mt-1 ml-2 text-success f-w-800" style="font-size: 16px;">{{ $t('approvedTrans.pass') }} </span>  
                          </b-row>
                        </b-row>
                        <b-row v-show="sealNo != ''" class="mb-1">
                          <b-col cols="4">{{ $t('approvedTrans.sealNo') }}</b-col>
                          <b-col>
                            <input v-model="sealNo" class="form-control" type="text" id="sealNo" disabled >
                          </b-col>
                        </b-row>
                        <div>
                          <table class="table table-bordered table-striped mx-auto">
                            <tr class="table-warning"><th class="col-sm-4" style="font-size: 14px">{{ $t('approvedTrans.checkpoint') }}</th><th class="gradient-gy">{{$t("approvedTrans.outside")}}</th><th class="gradient-yg">{{$t("approvedTrans.inside")}}</th><th>{{$t("approvedTrans.remark")}}</th></tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.leftSide') }}</td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="left_out">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="left_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="left_rem"></td>
                            </tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.rightSide') }}</td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="right_out">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="right_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="right_rem"></td>
                            </tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.door') }}</td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="door_out">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="door_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="door_rem"></td>
                            </tr>  
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.undercarriage') }}</td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="undercarriage_out">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td>
                              </td>
                              <td><input type="text" v-model="undercarriage_rem"></td>
                            </tr>                                   
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.roof') }}</td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="roof_out">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td>
                              </td>
                              <td><input type="text" v-model="roof_rem"></td>
                            </tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.ceiling') }}</td>                                              
                              <td>
                              </td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="ceiling_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="ceiling_rem"></td>
                            </tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.frontWall') }}</td>                                              
                              <td>
                              </td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="frontWall_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="frontWall_rem"></td>
                            </tr>
                            <tr class="gradient-wy">
                              <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.floor') }}</td>                                              
                              <td>
                              </td>                                              
                              <td>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" v-model="floor_in">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                              <td><input type="text" v-model="floor_rem"></td>
                            </tr>
                          </table>
                        </div>
                        <div>
                          <b-form-group>
                            <b-row class="my-2">
                              <h5 class="mx-3">{{ $t('approvedTrans.sumResult') }} : </h5>
                              <b-form-radio-group
                                id="btn-radios-2"
                                v-model="sumResult"
                                :options="sumOptions"
                                :button-variant="sumResult == 'reject' ? 'outline-danger': sumResult == 'condPass' ? 'outline-warning':'outline-success' "
                                size="sm"
                                name="radio-btn-outline"
                                buttons
                              ></b-form-radio-group>                                              
                            </b-row>
                            <b-row v-show="sumResult == 'condPass'" class="col-sm-12">
                              <h6 class="col-sm-3" >{{ $t('approvedTrans.specifyCond') }} : </h6>
                              <input class="col-sm-9" type="text" v-model="sum_rem">
                            </b-row>
                          </b-form-group>
                        </div>
                        <div class="row col-sm-12">
                          <h5 class="f-w-600 mt-2 mr-5">{{ $t("approvedTrans.inspr") }} : </h5> 
                          <input class="col-sm-4" type="text" v-model="inspecter">         
                          <div class="col-sm-4 ml-5">   
                            <datepicker 
                              v-model="inspDate"               
                              input-class="datepicker-here form-control digits" 
                              :disabled-dates="disabledDates"  
                              :format="format" 
                              :placeholder="$t('transport.datePh')"
                              :language="th"
                            >
                            </datepicker>              
                          </div>
                        </div>
                        <div class="d-flex flex-row justify-content-end mt-2">
                          <b-button
                            variant="warning"
                            size="sm"
                            class="mx-4"
                            @click="clickNo"
                            >
                            {{ $t('container.no') }}
                            </b-button>
                          <b-button
                            variant="primary"
                            size="sm"
                            class="float-right"
                            @click="clickSaveRecv"
                          >
                            {{ $t('seal.save') }}
                          </b-button>
                        </div>
                      </b-modal>                                
                      <div v-show="showUploadImage" class="gradient-gy card p-1" >
                        <div class="dashboard">
                          <!-- Image Upload Section -->
                          <div class="upload-section">
                            <input
                              type="file"
                              ref="fileInput"
                              accept="image/*"
                              multiple
                              @change="handleFileUpload"
                              style="display: none"
                            >
                            <div class="d-flex flex-row justify-content-between">
                              <feather @click="clickBack" class="text-white mt-2" type="arrow-left-circle"  size="30"></feather>                                            
                              <button @click="triggerFileInput" class="upload-btn" :disabled="images.length >= 10">
                                {{images.length < 6 ? $t('approvedTrans.uploadImageFor6') : images.length >= 10 ? $t('approvedTrans.uploadImageDone10') : $t('approvedTrans.uploadImageDone6') }}
                              </button>
                              <div class="mt-2"  style="text-align: end"><LocalSwitcher/></div>  
                            </div>

                            <p v-if="images.length < 6" class="upload-6Img-message"> {{$t('approvedTrans.6ImagesReqrMsg')  }}</p>
                            <p v-if="uploading" class="upload-status">Uploading... {{ uploadProgress }}%</p>
                          </div>
                          <!-- Horizontal Scroll View for Images -->
                          <div class="image-scroll-container">
                            <div class="image-scroll" ref="scrollContainer">
                              <div
                                class="image-item"
                                v-for="(image, index) in images"
                                :key="image.id"
                              >
                                <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                <button @click="deleteImage(image)" class="delete-btn" v-b-popover.hover.top="$t('approvedTrans.deleteEach')" >&times;</button>
                                <span class="image-counter">{{ index + 1 }} of {{ images.length }}</span>
                              </div>
                              <div v-if="images.length === 0" class="no-images">
                                {{$t('approvedTrans.noImageYet') }}
                              </div>
                            </div>
                          
                            <div class="scroll-controls" v-if="images.length > 1">
                              <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                                <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                                <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                              <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                            </div>
                          </div>
                        </div>
                          <div class=" d-flex flex-row justify-content-end">
                              <b-button
                              variant="warning"
                              @click="clickImage_NO"
                              class="notRequire-btn mx-4"                                        
                              >
                              {{ $t('approvedTrans.cancel') }}
                              </b-button>
                              <b-button
                              @click="saveImages"                                        
                              class="save-btn mx-4"
                              :disabled="images.length < 6 || images.length > 10 || uploading || fromExstImages"
                              >
                              {{ $t('approvedTrans.save6Images') }}
                              </b-button>
                          </div>
                      </div>
                      <div v-show="showUploadImageRecv" class="gradient-gy card p-1" >
                        <div class="dashboard">
                          <!-- Image Upload Section -->
                          <div class="upload-section">
                            <input
                              type="file"
                              ref="fileInputRecv"
                              accept="image/*"
                              multiple
                              @change="handleFileUploadRecv"
                              style="display: none"
                            >
                            <div class="d-flex flex-row justify-content-between">
                              <feather @click="clickBackRecv" class="text-white mt-2" type="arrow-left-circle"  size="30"></feather>                                            
                              <button @click="triggerFileInputRecv" class="upload-btn" :disabled="imagesRecv.length >= 10">
                                {{imagesRecv.length < 6 ? $t('approvedTrans.uploadImageFor6') : imagesRecv.length >= 10 ? $t('approvedTrans.uploadImageDone10') : $t('approvedTrans.uploadImageDone6') }}
                              </button>
                              <div class="mt-2"  style="text-align: end"><LocalSwitcher/></div>  
                            </div>

                            <p v-if="imagesRecv.length < 6" class="upload-6Img-message"> {{$t('approvedTrans.6ImagesReqrMsg')  }}</p>
                            <p v-if="uploadingRecv" class="upload-status">Uploading... {{ uploadProgressRecv }}%</p>
                          </div>
                          <!-- Horizontal Scroll View for Images -->
                          <div class="image-scroll-container">
                            <div class="image-scroll" ref="scrollContainer">
                              <div
                                class="image-item"
                                v-for="(image, index) in imagesRecv"
                                :key="image.id"
                              >
                                <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                <button @click="deleteImageRecv(image)" class="delete-btn" v-b-popover.hover.top="$t('approvedTrans.deleteEach')" >&times;</button>
                                <span class="image-counter">{{ index + 1 }} of {{ imagesRecv.length }}</span>
                              </div>
                              <div v-if="imagesRecv.length === 0" class="no-images">
                                {{$t('approvedTrans.noImageYet') }}
                              </div>
                            </div>
                          
                            <div class="scroll-controls" v-if="imagesRecv.length > 1">
                              <button @click="scrollLeftRecv" class="scroll-btn">&lt;&lt;</button>
                                <button @click="scrollLeftS1Recv" class="scroll-btn mx-2">&lt;</button>
                                <button @click="scrollRightS1Recv" class="scroll-btn mx-2">&gt;</button>
                              <button @click="scrollRightRecv" class="scroll-btn">&gt;&gt;</button>
                            </div>
                          </div>
                        </div>
                          <div class=" d-flex flex-row justify-content-end">
                              <b-button
                              variant="warning"
                              @click="clickImage_NO"
                              class="notRequire-btn mx-4"                                        
                              >
                              {{ $t('approvedTrans.cancel') }}
                              </b-button>
                              <b-button
                              @click="saveImagesRecv"                                        
                              class="save-btn mx-4"
                              :disabled="imagesRecv.length < 6 || imagesRecv.length > 10 || uploadingRecv || fromExstImagesRecv"
                              >
                              {{ $t('approvedTrans.save6Images') }}
                              </b-button>
                          </div>
                      </div>                            
                    </div> 
                    </div>
                  </div>
                </div>
             </div>
         </div>
     </div>
 </template>
 
 <script>
 import { storage , signOut, authUser ,getData, getDataWithinDays ,getDocId , deleteImageUrl, saveWithId, updateContNo, updateSealNo, updateTransStatusMatchTx, updateTransStatusRels,updateTransStatusRecv} from "../../firebase"
 import {en, th} from 'vuejs-datepicker/dist/locale'
 import LocalSwitcher from "../../components/localSwitcher.vue"
import { ref as storageRef, uploadBytesResumable, getDownloadURL} from 'firebase/storage';

export default {
  components: { LocalSwitcher }, 
  name: 'ApprovedTrans',
  data() {
      return{
        asOf : '',
        transInfo: '',
        showTransInfoModal: false,
        checked : false,
        en: en,
        th: th,
        format: "dd MM yyyy",
        userId : '',
        compId : '',
        showInspFormModalRels : false,
        showInspFormModalRecv : false,    
        transId : '',
        licensePlate: '',                    
        driverName: '',
        driverLicenseNo: '',
        contId: '',
        contNo: '',
        contNoExst: '',
        contSpecReqr: '',
        contSpecInsp: false,
        sealNo: '',
        sealNoExst: '',
        undercarriage_out : false,
        undercarriage_rem : '',
        left_in : false,
        left_out : false,
        left_rem : '',          
        right_in: false,
        right_out: false,
        right_rem: '',
        door_in: false,
        door_out: false,
        door_rem : '',
        roof_out: false,
        roof_rem : '',
        ceiling_in: false,
        ceiling_rem: '',
        frontWall_in: false,
        frontWall_rem: '',
        floor_in: false,
        floor_rem: '',
        sumResult:'',
        sum_rem: '',  
        inspecter: '',
        inspDate: '',             
        sumOptions: [
        { text:  `${this.$t('approvedTrans.passed')}`, value: 'passed' },
        { text:  `${this.$t('approvedTrans.reject')}`, value: 'reject' },
        { text: `${this.$t('approvedTrans.condPass')}`, value: 'condPass' }
        ],
        disabledDates: {
            to: new Date(Date.parse(new Date())-86400000),
        },
        isBusy: false,
        items: [],
        fields: [
        { key: 'transInfo', label: this.$t('approvedTrans.transId'), sortable: true },  
        { key: 'transStatus', label: this.$t('approvedTrans.transStatus'), sortable: true, variant: 'danger',
            formatter: value => {
            return this.$t(`matchTx.${value}`)
        }}, 
        { key: 'actDriver', label: this.$t('approvedTrans.action1'), sortable: true, variant: 'warning'},  
        { key: 'actDriverRecv', label: this.$t('approvedTrans.action2'), sortable: true, variant: 'info'},  
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 20,
        // pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortBy: 'startAt',
        sortDesc: true,
        url : '',
        showUploadImage : false,
        fromExstImages : false,
        images: [],
        uploading: false,
        uploadProgress: 0,
        urlRecv : '',
        showUploadImageRecv : false,
        fromExstImagesRecv : false,
        imagesRecv: [],
        uploadingRecv: false,
        uploadProgressRecv: 0
      }
  },
  created() {
    this.fetchImages()
    this.fetchImagesRecv()
  },
  mounted(){
    this.compId= localStorage.getItem("compId")      
    this.userId= localStorage.getItem("userId")   
    getDataWithinDays( "Transport", 'driverId' ,this.userId , 30,(res)=>{
      this.items = res
      this.totalRows= res.length
      this.asOf = this.$moment().format( "HH:mm  DD-MM-YYYY")
    })
  },

  methods: {
    refreshTaskList(){
      this.isBusy = true
      this.refresh()
      this.showInspFormModalRels = false
      this.showInspFormModalRecv = false
      this.showTransInfoModal = false
      this.showUploadImage = false
      getDataWithinDays( "Transport", 'driverId' ,this.userId , 30,(res)=>{
        this.items = res
        this.totalRows= res.length
        this.asOf = this.$moment().format( "HH:mm  DD-MM-YYYY")
        this.isBusy = false
      })
    },
    logout() {
      this.$bvModal.msgBoxConfirm(this.$t('approvedTrans.confirmLogout'), {
      title: this.$t('matchTx.plsConfirm'),
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'danger',
      okTitle: this.$t('refill.exit'),
      cancelTitle: this.$t('matchTx.no'),
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
      })
      .then(async(value) => {
          if (value) {
            localStorage.clear('user')
            localStorage.clear('userId')
            localStorage.clear('userCat')
            localStorage.clear('phone')
            localStorage.clear('name')                       
            signOut(authUser);
            this.$router.push('/auth/login');            
          } else {
            return
          }
      })
      .catch(error => {
          this.$toasted.show( `Action-Logout: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
      })
    }, 
    googleMapsLinkRels() { 
      window.location.href = `https://www.google.com/maps/place/${this.transInfo.locRels.lat},${this.transInfo.locRels.lng}` 
    },
    googleMapsLinkReqr() { 
      window.location.href = `https://www.google.com/maps/place/${this.transInfo.locReqr.lat},${this.transInfo.locReqr.lng}` 
    },
    async openModalTransInfo(item, button) {
      await getData('MatchTx', 'mTxId', item.transId, async(res)=>{
        this.transInfo ={ 
          startAt : item.startAt,
          ...res[0]
        }
        this.$root.$emit('bv::show::modal', "transInfoModal" , button)
      })
    },
    async actInspRels( item ){
      await this.actInsp( 'EIR', item, true , false)
    },
    async actInspRecv( item ){
      await this.actInsp( 'EirRecv', item , false , true)
    },
    async actInsp(eirColl, item , inspModalRels , inspModalRecv) {
      await getData(eirColl, 'transId', item.transId, async(eir)=>{
        if (eir.length == 0) {
          this.transId = item.transId            
          this.licensePlate = item.licensePlate
          await getData('Users', 'userId', item.driverId, async(res)=>{
            this.driverName = res[0].name
            this.inspecter = res[0].name
          })
          await getData('Driver', 'driverId', item.driverId, async(res)=>{
            this.driverLicenseNo = res[0].driverLicenseNo
          })
          await getData('MatchTx', 'mTxId', item.transId, async(res)=>{          
            this.contId = res[0].contId
            this.contNo = res[0].contNo
            this.contNoExst = res[0].contNo
            this.contSpecReqr = `${res[0].contSize}-${res[0].contType}-Grade: ${res[0].contGrade}`
            this.sealNo= res[0].sealNo
            this.sealNoExst= res[0].sealNo

          }).then(()=>{
            this.left_rem = this.$t('approvedTrans.left_remDefualt')
            this.right_rem = this.$t('approvedTrans.right_remDefualt')
            this.door_rem = this.$t('approvedTrans.door_remDefualt')
            this.roof_rem = this.$t('approvedTrans.roof_remDefualt')
            this.ceiling_rem = this.$t('approvedTrans.ceiling_remDefualt')
            this.frontWall_rem = this.$t('approvedTrans.frontWall_remDefualt')
            this.floor_rem = this.$t('approvedTrans.floor_remDefualt')
            this.showInspFormModalRels = inspModalRels
            this.showInspFormModalRecv = inspModalRecv
          })
        } else {
          this.transId = item.transId            
          this.licensePlate = eir[0].licensePlate
          this.contId = eir[0].contId
          // this.contNo = eir[0].contNo
          this.licensePlate = eir[0].licensePlate   
          this.driverName = eir[0].driverName
          this.driverLicenseNo = eir[0].driverLicenseNo
          this.contSpecInsp= eir[0].contSpecInsp
          await getData( 'Container' , 'contId', eir[0].contId , (res)=>{
            this.contSpecReqr = `${res[0].contSize}-${res[0].contType}-Grade: ${res[0].contGrade}`
            this.contNo =res[0].contNo
          })          
          this.sealNo= eir[0].sealNo,
          this.undercarriage_out = eir[0].undercarriage_out
          this.undercarriage_rem = eir[0].undercarriage_rem
          this.left_in = eir[0].left_in
          this.left_out = eir[0].left_out
          this.left_rem = eir[0].left_rem       
          this.right_in = eir[0].right_in
          this.right_out = eir[0].right_out
          this.right_rem = eir[0].right_rem
          this.door_in = eir[0].door_in
          this.door_out = eir[0].door_out
          this.door_rem = eir[0].door_rem
          this.roof_out = eir[0].roof_out
          this.roof_rem = eir[0].roof_rem
          this.ceiling_in = eir[0].ceiling_in
          this.ceiling_rem = eir[0].ceiling_rem
          this.frontWall_in = eir[0].frontWall_in
          this.frontWall_rem = eir[0].frontWall_rem
          this.floor_in = eir[0].floor_in
          this.floor_rem = eir[0].floor_rem
          this.sumResult = eir[0].sumResult
          this.sum_rem = eir[0].sum_rem
          this.inspecter = eir[0].inspecter
          this.inspDate= this.$moment(eir[0].inspDate).format( "YYYY-MM-DD")
          this.showInspFormModalRels = inspModalRels
          this.showInspFormModalRecv = inspModalRecv
        }
      })
    },

    async actUploadImage(item) {
      await getData('MatchTx', 'mTxId', item.transId, async(res)=>{
        this.contId = res[0].contId
        this.fetchImages()        
        this.showUploadImage = true
      })
    },   
    async actUploadImageRecv(item) {
      await getData('MatchTx', 'mTxId', item.transId, async(res)=>{
        this.contId = res[0].contId
        this.fetchImagesRecv()
        this.showUploadImageRecv = true
      })
    }, 
    async actCloseJobRels(item) {
      this.actCloseJobLoc(item , 'EIR' , 'Cont6Images' , 'doneRels')
    },  

    async actCloseJobRecv(item) {
      if (item.transStatus1 != 'done' ) {
        this.$toasted.show(this.$t('approvedTrans.plsRelsDoneMsg'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});  
      } else {
        this.actCloseJobLoc(item , 'EirRecv' , 'Cont6ImagesRecv' , 'doneRecv') 
      }
    },  
    async actCloseJobLoc(item , eirColl , imagesColl , transStatusMtx) {
      await getData('MatchTx', 'mTxId', item.transId, async(res)=>{
        await getData(eirColl , 'contId' , res[0].contId , async(e)=>{
          if ( e.length == 0 || e[0].sumResult == '') {
            this.$toasted.show(this.$t('approvedTrans.plsInspMsg'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});       
          } else {
            await getData(imagesColl , 'contId' , res[0].contId , async(i)=>{
              if (i.length == 0 || i[0].url6.length < 6 ) {
                this.$toasted.show(this.$t('approvedTrans.pls6ImagesMsg'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});     
              } else {
                this.$bvModal.msgBoxConfirm(this.$t('approvedTrans.confirmCloseJob'), {
                title: this.$t('matchTx.plsConfirm'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: this.$t('matchTx.yes'),
                cancelTitle: this.$t('matchTx.no'),
                cancelVariant: 'warning',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
                })
                .then(async(value) => {
                  if (value){
                  await updateTransStatusMatchTx( item.transId, transStatusMtx)                
                    if (transStatusMtx == 'doneRels') {
                      await updateTransStatusRels( 'Transport',  item.transId, 'done', 'done').then(async()=>{
                        await getDataWithinDays( "Transport", 'driverId' ,this.userId , 30,(res)=>{
                          this.items = res
                          this.totalRows= res.length
                          this.asOf = this.$moment().format( "HH:mm  DD-MM-YYYY")
                        })
                        this.$toasted.show(this.$t('approvedTrans.successCloseJob'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                         
                      })
                    } else {
                      await updateTransStatusRecv( 'Transport',  item.transId, 'done', 'done').then(async()=>{
                        await getDataWithinDays( "Transport", 'driverId' ,this.userId , 30,(res)=>{
                          this.items = res
                          this.totalRows= res.length
                          this.asOf = this.$moment().format( "HH:mm  DD-MM-YYYY")
                        })
                        this.$toasted.show(this.$t('approvedTrans.successCloseJob'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                         
                      })                      
                    }
                  }
                })
                .catch(error => {
                  this.$toasted.show( `Action-CloseJob: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                })
              }
            })
          }
        })
      })    
    },  
    async actEditRels(item) {
      await this.actEditLoc(item , 'editRels')
    },  
    async actEditRecv(item) {
      await this.actEditLoc(item , 'editRecv')
    }, 
    async actEditLoc(item ,  transStatusMtx) {
      this.$bvModal.msgBoxConfirm(this.$t('approvedTrans.confirmEdit'), {
      title: this.$t('matchTx.plsConfirm'),
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'info',
      okTitle: this.$t('matchTx.yes'),
      cancelTitle: this.$t('matchTx.no'),
      cancelVariant: 'warning',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
      })
      .then(async(value) => {
        if (value){
          await updateTransStatusMatchTx( item.transId,  transStatusMtx)                
          if ( transStatusMtx == 'editRels') {
            await updateTransStatusRels( 'Transport',  item.transId, 'edit' ,'edit').then(async()=>{
            await getDataWithinDays( "Transport", 'driverId' ,this.userId , 30,(res)=>{
              this.items = res
              this.totalRows= res.length
              this.asOf = this.$moment().format("HH:mm  DD-MM-YYYY")
            })
            this.$toasted.show(this.$t('approvedTrans.successEdit'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                         
          })
          } else {
            await updateTransStatusRecv( 'Transport',  item.transId, 'edit' ,'edit').then(async()=>{
              await getDataWithinDays( "Transport", 'driverId' ,this.userId , 30,(res)=>{
                this.items = res
                this.totalRows= res.length
                this.asOf = this.$moment().format("HH:mm  DD-MM-YYYY")
              })
              this.$toasted.show(this.$t('approvedTrans.successEdit'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                         
            })            
          }
        }
      })
      .catch(error => {
        this.$toasted.show( `Action-Edit: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
      })
    }, 
    async clickNo() {
      this.refresh()
      this.showInspFormModalRels = false
      this.showInspFormModalRecv = false
    },
    async clickSaveRels (){
      await this.clickSave( 'EIR' , )
    },
    async clickSaveRecv (){
      await this.clickSave( 'EirRecv')
    },
    async clickSave(eirColl) {
      const licensePlatePattern = /^[\dA-Za-z\p{Script=Thai}]+$/u
      let msg = 'completed'
      if (this.contNo ==='') {
        msg = 'release.addSelectedCont'
      } else if (this.contNo =='Dummy' || this.contNo == 'dummy'){
        msg = 'approvedTrans.addContNo'
      } else if (this.driverName ===''){
        msg = 'transport.addSelectedDriver'
      } else if (this.licensePlate ===''){
        msg = 'truck.addLicensePlate'
      } else if (!licensePlatePattern.test(this.licensePlate)){
        msg = this.$t('truck.licensePlateFormatMsg')
      } else if (this.inspecter === ''){
        msg = this.$t('approvedTrans.addInspr')
      } else if (this.inspDate=== ''){
        msg = this.$t('approvedTrans.addInspDate')
      }  
      if (msg === 'completed'){
        let payload = {
          contId: this.contId,
          contNo: this.contNo,
          transId: this.transId,
          licensePlate: this.licensePlate,    
          driverName : this.driverName,
          driverLicenseNo: this.driverLicenseNo,
          compId: this.compId,   
          contSpecInsp: this.contSpecInsp,
          sealNo: this.sealNo,
          undercarriage_out : this.undercarriage_out,
          undercarriage_rem : this.undercarriage_rem,
          left_in : this.left_in,
          left_out : this.left_out,
          left_rem : this.left_rem,          
          right_in: this.right_in,
          right_out: this.right_out,
          right_rem: this.right_rem,
          door_in: this.door_in,
          door_out: this.door_out,
          door_rem : this.door_rem,
          roof_out: this.roof_out,
          roof_rem : this.roof_rem,
          ceiling_in: this.ceiling_in,
          ceiling_rem: this.ceiling_rem,
          frontWall_in: this.frontWall_in,
          frontWall_rem: this.frontWall_rem,
          floor_in: this.floor_in,
          floor_rem: this.floor_rem,
          sumResult: this.sumResult,
          sum_rem: this.sum_rem,
          inspecter: this.inspecter,
          inspDate: Date.parse(this.inspDate),
          timestamp: new Date().valueOf(),                     
        }
        await saveWithId(eirColl, this.contId, payload).then(async()=>{
          if (this.contNo != this.contNoExst && this.contNo != '') {
            await updateContNo( "Container", this.contId, this.contNo)
            await updateContNo( "MatchTx", this.transId, this.contNo)
            await getDocId("Release" , "contId" , this.contId , async(res)=>{
                if (res.length != 0) {
                  for (let i = 0; i < res.length; i++) {
                  await updateContNo( "Release", res[i], this.contNo)   
                  }
                }
            })    
          }
          if (this.sealNo != this.sealNoExst && this.sealNo != '') {
            await updateSealNo("MatchTx", this.transId, this.sealNo)
          }
          this.refresh()
          this.showInspFormModalRels = false
          this.showInspFormModalRecv = false
          this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                         
        })  
      }else{
        this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
      }
    },
    async refresh(){
      this.transId = ''          
      this.licensePlate = ''
      this.contId = ''
      this.contNo = ''
      this.licensePlate = '' 
      this.driverName = ''
      this.driverLicenseNo = ''
      this.contSpecInsp= false
      this.sealNo= '',
      this.undercarriage_out = false
      this.undercarriage_rem = ''
      this.left_in = false
      this.left_out = false
      this.left_rem = ''     
      this.right_in = false
      this.right_out = false
      this.right_rem = ''
      this.door_in = false
      this.door_out = false
      this.door_rem = ''
      this.roof_out = false
      this.roof_rem = ''
      this.ceiling_in = false
      this.ceiling_rem = ''
      this.frontWall_in = false
      this.frontWall_rem = ''
      this.floor_in = false
      this.floor_rem = ''
      this.sumResult = ''
      this.sum_rem = ''
      this.inspecter = ''
      this.inspDate= ''
      },
    async clickBack() {
        this.showUploadImage = false
    },
    async clickBackRecv() {
        this.showUploadImageRecv = false
    },
    async clickImage_NO() {
        this.contId = ''
        this.images = []
        this.imagesRecv = []
        this.showUploadImageRecv = false        
        this.showUploadImage = false

    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    triggerFileInputRecv() {
      this.$refs.fileInputRecv.click();
    },
    async handleFileUpload(event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;
    
      // Limit to 6 images total  => 10
      const remainingSlots = 10 - this.images.length;
      if (remainingSlots <= 0) {
        this.$toasted.show(this.$t('approvedTrans.max10Images'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});     
        // alert(`${this.$t('approvedTrans.max6Images')}`);
        return;
      }
    
      const filesToUpload = Array.from(files).slice(0, remainingSlots);
      this.uploading = true;
    
      for (const file of filesToUpload) {
        try {
          const url = await this.uploadImage(file);
          this.images.push({
            id: Date.now().toString(), // temporary ID
            url,
            // file // keep reference for saving later
          });
        } catch (error) {
          console.error('Upload failed:', error);
          this.$toasted.show(this.$t('approvedTrans.failedUpload'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});     
        }
      }
      this.fromExstImages = false
      this.uploading = false;
      this.$refs.fileInput.value = ''; // reset input
    },
    async handleFileUploadRecv(event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;
      // Limit to 6 images total
      const remainingSlots = 10 - this.imagesRecv.length;
      if (remainingSlots <= 0) {
        this.$toasted.show(this.$t('approvedTrans.max10Images'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});     
        return;
      }
      const filesToUpload = Array.from(files).slice(0, remainingSlots);
      this.uploadingRecv = true;
    
      for (const file of filesToUpload) {
        try {
          const url = await this.uploadImage(file);
          this.imagesRecv.push({
            id: Date.now().toString(), // temporary ID
            url,
            // file // keep reference for saving later
          });
        } catch (error) {
          console.error('Upload failed:', error);
          this.$toasted.show(this.$t('approvedTrans.failedUpload'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});     
          // alert(`${this.$t('approvedTrans.failedUpload')}`);
          
        }
      }
      this.fromExstImagesRecv = false
      this.uploadingRecv = false;
      this.$refs.fileInputRecv.value = ''; // reset input
    },
    async uploadImage(file) {
      return new Promise((resolve, reject) => {
        const storageReference = storageRef(storage, `images/${Date.now()}_${file.name}`);
        const uploadTask = uploadBytesResumable(storageReference, file);
      
        uploadTask.on('state_changed',
          (snapshot) => {
            this.uploadProgress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          },
          (error) => {
            reject(error);
          },
          async () => {
            try {
              const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
              resolve(downloadURL);
            } catch (error) {
              reject(error);
            }
          }
        );
      });
    },

    async fetchImages() {
      try {
        await getData('Cont6Images' , 'contId' , this.contId , (res)=>{
          if (res.length  != 0) {
            this.images = res[0].url6
            if (this.images.length >= 6) {
              this.fromExstImages = true
            }
          } else{
            this.images = []
          }
        })
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    },
    async fetchImagesRecv() {
      try {
        await getData('Cont6ImagesRecv' , 'contId' , this.contId , (res)=>{
          if (res.length  != 0) {
            this.imagesRecv = res[0].url6
            if (this.imagesRecv.length >= 6) {
              this.fromExstImagesRecv = true
            }
          } else{
            this.imagesRecv = []
          }
        })
      } catch (error) {
        console.error('Error fetching imagesRecv:', error);
      }
    },
    async saveImages() {
      if (this.images.length === 0) return;
      try {
        // Filter out images that are already saved (have a Firestore ID)        
        const imagesToSave = this.images.filter(img => !img.id.startsWith('temp-'));        
        // console.log(`imagesToSave => ${JSON.stringify(imagesToSave)}`)        
        this.uploading = true;
        let payload = {
          contId: this.contId,          
          url6 : imagesToSave,
          timestamp: new Date().valueOf()
        }
        // console.log(`saveImages, payload => ${JSON.stringify(payload)}`)    
        await saveWithId('Cont6Images' , this.contId, payload)
        await this.fetchImages(); // Refresh the list        
        this.$toasted.show(this.$t('approvedTrans.successSaveImage'), {theme: 'bubble', position: 'top-center', type: 'success' , duration: 5000});     
      } catch (error) {
        console.error('Error saving images:', error);
        // alert('Failed to save images');
        this.$toasted.show(this.$t('approvedTrans.failedSaveImage'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});     
      } finally {
        this.uploading = false;
      }
    },
    async saveImagesRecv() {
      if (this.imagesRecv.length === 0) return;
    
      try {
        // Filter out images that are already saved (have a Firestore ID)        
        const imagesToSave = this.imagesRecv.filter(img => !img.id.startsWith('temp-'));        
        // console.log(`imagesToSave => ${JSON.stringify(imagesToSave)}`)        
        this.uploadingRecv = true;
        let payload = {
          contId: this.contId,          
          url6 : imagesToSave,
          timestamp: new Date().valueOf()
        }
        // console.log(`saveImages, payload => ${JSON.stringify(payload)}`)    
        await saveWithId('Cont6ImagesRecv' , this.contId, payload)
        await this.fetchImagesRecv(); // Refresh the list        
        this.$toasted.show(this.$t('approvedTrans.successSaveImage'), {theme: 'bubble', position: 'top-center', type: 'success' , duration: 5000});     
      } catch (error) {
        console.error('Error saving images:', error);
        // alert('Failed to save images');
        this.$toasted.show(this.$t('approvedTrans.failedSaveImage'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});     
      } finally {
        this.uploadingRecv = false;
      }
    },
    async deleteImage(image) {
      this.$bvModal.msgBoxConfirm(this.$t('approvedTrans.confirmDeleteImageMsg'), {
      title: this.$t('matchTx.plsConfirm'),
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'warning',
      okTitle: this.$t('matchTx.yes'),
      cancelTitle: this.$t('matchTx.no'),
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
      })
      .then(async(value) => {
        if (value){
          try {
            deleteImageUrl('images' , image.url)
            // Remove from local array
            this.images = this.images.filter(img => img.id !== image.id);
            let payload = {
              contId: this.contId,          
              url6 : this.images,
              timestamp: new Date().valueOf()
            }  
            await saveWithId('Cont6Images' , this.contId, payload)  // overwrite whole document.
            await this.fetchImages(); // Refresh the list
          } catch (error) {
            console.error('Error deleting image:', error);
            this.$toasted.show(this.$t('approvedTrans.failedDeleteImageMsg'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
          }
        }
      })
      .catch(error => {
        this.$toasted.show( `Action-Delete Image: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
      })
    },  
    async deleteImageRecv(image) {
      this.$bvModal.msgBoxConfirm(this.$t('approvedTrans.confirmDeleteImageMsg'), {
      title: this.$t('matchTx.plsConfirm'),
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'warning',
      okTitle: this.$t('matchTx.yes'),
      cancelTitle: this.$t('matchTx.no'),
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
      })
      .then(async(value) => {
        if (value){
          try {
            deleteImageUrl('images' , image.url)
            // Remove from local array
            this.imagesRecv = this.imagesRecv.filter(img => img.id !== image.id);
            let payload = {
              contId: this.contId,          
              url6 : this.imagesRecv,
              timestamp: new Date().valueOf()
            }  
            await saveWithId('Cont6ImagesRecv' , this.contId, payload)  // overwrite whole document.
            await this.fetchImagesRecv(); // Refresh the list
          } catch (error) {
            console.error('Error deleting image:', error);
            this.$toasted.show(this.$t('approvedTrans.failedDeleteImageMsg'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
          }
        }
      })
      .catch(error => {
        this.$toasted.show( `Action-Delete ImageRecv: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
      })
    },  

    scrollLeft() {
      this.$refs.scrollContainer.scrollBy({
        left: -window.innerWidth * 1.0,
        behavior: 'smooth'
      });
    },
    scrollLeftRecv() {
      this.$refs.scrollContainerRecv.scrollBy({
        left: -window.innerWidth * 1.0,
        behavior: 'smooth'
      });
    },
    scrollLeftS1() {
      this.$refs.scrollContainer.scrollBy({
        left: -window.innerWidth * 0.2,
        behavior: 'smooth'
      });
    },
    scrollLeftS1Recv() {
      this.$refs.scrollContainerRecv.scrollBy({
        left: -window.innerWidth * 0.2,
        behavior: 'smooth'
      });
    },    
    scrollRight() {
      this.$refs.scrollContainer.scrollBy({
        left: window.innerWidth * 1.0,
        behavior: 'smooth'
      });
    },
    scrollRightRecv() {
      this.$refs.scrollContainerRecv.scrollBy({
        left: window.innerWidth * 1.0,
        behavior: 'smooth'
      });
    },
    scrollRightS1() {
      this.$refs.scrollContainer.scrollBy({
        left: window.innerWidth * 0.2,
        behavior: 'smooth'
      });
    },
    scrollRightS1Recv() {
      this.$refs.scrollContainerRecv.scrollBy({
        left: window.innerWidth * 0.2,
        behavior: 'smooth'
      });
    },
    toggle_fullscreen() {
        if ((document.fullScreenElement && document.fullScreenElement !== null) ||
            (!document.mozFullScreen && !document.webkitIsFullScreen)) {
            if (document.documentElement.requestFullScreen) {
            document.documentElement.requestFullScreen();
            } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullScreen) {
            document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (document.cancelFullScreen) {
            document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
            }
        }
    }
  }
}
 </script>
 <style scoped>
 .frameB {
     max-width: 100%;
     height: auto;
     border-radius: 5px;
 }
 .frameT {
     width: 100%;
     height: 100%;
     border-radius: 5px;
 }
 .pdfLogo {
     width: 100%;
     height: 100%;
 }
 .pdfFrameB {
     width: 80%;
     height: 80%;
     border-radius: 5px;
 }
 .gradient-gy {
   background: linear-gradient(135deg, green, yellow);
 }
 .gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-rbl {
   background: linear-gradient(45deg, red, blue);
 }
 .gradient-overAll {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-work {
   background: linear-gradient(135deg, white, rgb(147, 184, 235));
 }
 .gradient-fin {
   background: linear-gradient(45deg, white, rgb(161, 91, 91));
 }
 .gradient-love {
   background: linear-gradient(45deg, white, pink);
 }
 .gradient-hlth {
   background: linear-gradient(45deg, white, rgb(74, 117, 74));
 }
 .gradient-lucky {
   background: linear-gradient(45deg, white, rgb(146, 140, 110));
 }
 .gradient-gr {
   background: linear-gradient(45deg, green, red);
 }
 .gradient-rw {
   background: linear-gradient(45deg, rgb(255, 166, 0), white);
 }
 .gradient-gw {
   background: linear-gradient(45deg, green, white);
 }
 .gradient-wg {
   background: linear-gradient(45deg, white, green);
 }
 .gradient-pw {
   background: linear-gradient(45deg, pink, white);
 }
 
 /* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN OFF */
  background-color: #ccc; /* Example: Gray when off */
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

/* Change background color of the slider when checked (ON state) */
input:checked + .slider {
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN ON */
  background-color: #2196F3; /* Example: Blue when on */
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}
.delete{
    z-index: 999;
    color:#fe0000;
}

.dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}

.upload-section {
  margin-bottom: 20px;
  text-align: center;
}
.upload-btn {
  background-color: #080cef;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
  width: 50%;
  margin-bottom: 10px;
}
.notRequire-btn {
  background-color: #b8b525;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  width: 50%;
  margin-bottom: 10px;
}
.save-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  width: 50%;
  margin-bottom: 10px;
}

.upload-btn:disabled, .save-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
.upload-6Img-message {
  font-size:  16px;
  color: #1a0fe7;
}
.upload-status {
  font-size: 14px;
  color: #666;
} 
.image-scroll-container {
  position: relative;
  margin: 20px 0;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome/Safari */
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}

.display-image {
  width: 100%;
  height: 250px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
}

.delete-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

.image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

@media (max-width: 480px) {
  .image-item {
    flex: 0 0 95%;
  }
 
  .display-image {
    height: 200px;
  }
}

 </style>
 